import { render, staticRenderFns } from "./FormTemplateModal.vue?vue&type=template&id=971e3074"
import script from "./FormTemplateModal.vue?vue&type=script&lang=js"
export * from "./FormTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('971e3074')) {
      api.createRecord('971e3074', component.options)
    } else {
      api.reload('971e3074', component.options)
    }
    module.hot.accept("./FormTemplateModal.vue?vue&type=template&id=971e3074", function () {
      api.rerender('971e3074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/FormTemplateModal.vue"
export default component.exports